import React, { useState } from "react";
import { Link } from "react-router-dom";
import {MdNotificationsActive} from 'react-icons/md'
import logo from "./images/ClowdsIcon.png"
const UserProfile = () => {
  return (
    <div id="menu" className="bg-[#151c2c] col-span-3 rounded-lg p-4 ">
      <h1 className="font-bold text-lg lg:text-3xl bg-gradient-to-br from-white via-white/50 to-transparent bg-clip-text text-transparent">
        Creator <span className="text-indigo-400"></span>
      </h1>
      <p className="text-slate-400 text-sm mb-2">Welcome back,</p>
      <a className="flex flex-col space-y-2 md:space-y-0 md:flex-row mb-5 items-center md:space-x-2 hover:bg-white/10 group transition duration-150 ease-linear rounded-lg group w-full py-3 px-2">
        <div>
          <img
            className="rounded-full w-10 h-10  object-cover"
            src={logo}
            alt=""
          />
        </div>
        
      </a>
      <hr className="my-2 border-slate-700" />
      <div id="menu" className="flex flex-col space-y-2 my-5">
        <a className="hover:bg-white/10 transition duration-150 ease-linear rounded-lg py-3 px-2 group">
          <div className="flex flex-col space-y-2 md:flex-row md:space-y-0 space-x-2 items-center">
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="w-6 h-6 group-hover:text-indigo-400"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
                />
              </svg>
            </div>
            <Link to="/dashboard">
            <div>
              <p className="font-bold text-base lg:text-lg text-slate-200 leading-4 group-hover:text-indigo-400">
                Dashboard
              </p>
              <p className="text-slate-400 text-sm hidden md:block">
                Data overview
              </p>
            </div>
            </Link>
          </div>
        </a>
        <div className="hover:bg-white/10 transition duration-150 ease-linear rounded-lg py-3 px-2 group">
          <div
            // data-dropdown-toggle="dropdown"
            id="dropdownDefaultButton"
            className="relative flex hover:cursor-pointer flex-col space-y-2 md:flex-row md:space-y-0 space-x-2 items-center"
          >
            <div>
              <MdNotificationsActive
                size={30}
                className="w-6 h-6 group-hover:text-indigo-400"
              />
             
            </div>
            
            <div>
              <p className="font-bold hover:cursor-pointer text-base lg:text-lg text-slate-200 leading-4 group-hover:text-indigo-400">
                Notifications
              </p>
              <p className="text-slate-400 text-sm hidden md:block">
                Access Requests
              </p>
             
            </div>

          </div>
        </div>
        <a className="hover:bg-white/10 transition duration-150 ease-linear rounded-lg py-3 px-2 group">
          <div className="flex flex-col space-y-2 md:flex-row md:space-y-0 space-x-2 items-center">
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="w-6 h-6 group-hover:text-indigo-400"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z"
                />
              </svg>
            </div>
            <div>
              <p className="font-bold text-base lg:text-lg text-slate-200 leading-4 group-hover:text-indigo-400">
                Users
              </p>
              <p className="text-slate-400 text-sm hidden md:block">Manage users</p>
            </div>
          </div>
        </a>
        <a className="hover:bg-white/10 transition duration-150 ease-linear rounded-lg py-3 px-2 group">
          <div className="flex flex-col space-y-2 md:flex-row md:space-y-0 space-x-2 items-center">
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="w-6 h-6 group-hover:text-indigo-400"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.24-.438.613-.431.992a6.759 6.759 0 010 .255c-.007.378.138.75.43.99l1.005.828c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.57 6.57 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.28c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.02-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.992a6.932 6.932 0 010-.255c.007-.378-.138-.75-.43-.99l-1.004-.828a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.281z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                />
              </svg>
            </div>
            <div>
              <p className="font-bold text-base lg:text-lg text-slate-200 leading-4 group-hover:text-indigo-400">
                Logout
              </p>
              
            </div>
          </div>
        </a>
      </div>
    </div>
  );
};

export default UserProfile;
